import React, { useState } from 'react';
import { ILogTContent } from '../../models/logTContent';
import { ILogt } from '../../models/logT';

interface BetaMessageDetailProps {
  row: ILogt;
  content: ILogTContent | null;
  isLoading: boolean;
  hasError: boolean;
  onClose?: () => void;
}

const formatTS = (ts: Date | string | null | undefined): string => {
  if (!ts) return '—';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return String(ts);
  return d.toLocaleString();
};

const BetaMessageDetail: React.FC<BetaMessageDetailProps> = ({ row, content, isLoading, hasError, onClose }) => {
  const [wrapText, setWrapText] = useState(true);

  const direction = (row as any)?.Direction ?? (row as any)?.direction;
  const dirNum = Number(direction);
  let dirLabel = String(direction ?? '—');
  if (dirNum === 0) {
    dirLabel = 'Uplink ↑';
  } else if (dirNum === 1) {
    dirLabel = 'Downlink ↓';
  }

  const aircraftId = (row as any).AircraftId || (row as any).aircraftId || '—';
  const flightId = (row as any).FlightId || (row as any).flightId || '—';
  const origin = (row as any).DepartureAirportIATA || (row as any).departureAirportIATA || '—';
  const destination = (row as any).ArrivalAirportIATA || (row as any).arrivalAirportIATA || '—';
  const timestamp = formatTS((row as any).logtTS || (row as any).LogtTS);
  const messageType = (row as any).MessageType || (row as any).messageType || '—';
  const smi = (row as any).SMI || (row as any).smi || '—';
  const medium = (row as any).Medium || (row as any).medium || '—';

  return (
    <div className="beta-message-detail">   

      {/* ── Content header: Aircraft/Flight/Route + actions ─────────────────────── */}
      <div className="beta-message-detail-header">
        <div className="beta-message-detail-title" style={{ display: 'flex', gap: '0', alignItems: 'center' }}>
          <span style={{ fontSize: '13px', fontWeight: 700, color: 'var(--beta-color-primary)', marginRight: '8px', textTransform: 'uppercase' }}>Message Content</span>
          <span style={{ color: 'var(--beta-color-border)', margin: '0 8px' }}>|</span>
          <span><strong>Aircraft:</strong> {aircraftId}</span>
          <span style={{ color: 'var(--beta-color-border)', margin: '0 8px' }}>|</span>
          <span><strong>Flight:</strong> {flightId}</span>
          <span style={{ color: 'var(--beta-color-border)', margin: '0 8px' }}>|</span>
          <span><strong>Route:</strong> {origin} → {destination}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <button type="button" className="beta-message-detail-toggle" onClick={() => setWrapText(w => !w)}>
            <span className="beta-message-detail-toggle-label">{wrapText ? 'Wrap ON' : 'Wrap OFF'}</span>
            <div className={`beta-message-detail-toggle-track ${wrapText ? 'beta-message-detail-toggle-track--on' : 'beta-message-detail-toggle-track--off'}`}>
              <div className={`beta-message-detail-toggle-thumb ${wrapText ? 'beta-message-detail-toggle-thumb--on' : 'beta-message-detail-toggle-thumb--off'}`} />
            </div>
          </button>
          {onClose && (
            <button 
              type="button" 
              onClick={onClose} 
              style={{ background: 'none', border: 'none', color: 'inherit', fontSize: '1.5rem', cursor: 'pointer', padding: '0 4px' }}
              title="Close"
            >
              &times;
            </button>
          )}
        </div>
      </div>

      {/* ── Message body ────────────────────────────────────────────── */}
      <div className="beta-message-detail-body">
        {isLoading && (
          <div className="beta-message-detail-loading">
            <div className="beta-grid-spinner" />
            <span className="beta-message-detail-loading-text">Loading message…</span>
          </div>
        )}
        {!isLoading && (hasError || !content) && (
          <div className="beta-message-detail-error">Failed to load message content.</div>
        )}
        {!isLoading && content && (
          wrapText ? (
            <pre className="beta-message-detail-content message-pre">
              {content.msg}
            </pre>
          ) : (
            <p className="beta-message-detail-content">
              {content.msg}
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default BetaMessageDetail;

